import { Box } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import Address from '../../models/Address';
import AddressMapResult, { CustomMapBounds } from '../../models/AddressMapResult';
import { buildStaticMapUrl } from './multiMapUtils';

interface MultiMapPrintViewProps {
  addresses: Address[] | AddressMapResult[];
  mapBounds?: CustomMapBounds;
  zoomOnSingle: number;
}

const MultiMapPrintView: React.FC<MultiMapPrintViewProps> = ({
  addresses,
  mapBounds,
  zoomOnSingle,
}) => {
  const staticMapUrl = useMemo(
    () =>
      buildStaticMapUrl(addresses, {
        printMode: true,
        mapBounds,
        zoomOnSingle,
      }),
    [addresses, mapBounds, zoomOnSingle],
  );

  const [staticUrlReady, setStaticUrlReady] = useState(false);

  useEffect(() => {
    setStaticUrlReady(staticMapUrl !== null);
  }, [staticMapUrl]);

  if (staticUrlReady && staticMapUrl) {
    return (
      <Box
        component="img"
        className="static-map"
        src={staticMapUrl}
        alt="Opportunity location map"
        sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        color: '#666',
      }}
    >
      Loading map...
    </Box>
  );
};

export default MultiMapPrintView;
